import { render, staticRenderFns } from "./ExternalContent.vue?vue&type=template&id=fbd4741c&scoped=true&"
import script from "./ExternalContent.vue?vue&type=script&lang=js&"
export * from "./ExternalContent.vue?vue&type=script&lang=js&"
import style0 from "./ExternalContent.vue?vue&type=style&index=0&id=fbd4741c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd4741c",
  null
  
)

export default component.exports